import gql from 'graphql-tag';

export const GET_TASK_SMS_HISTORY = gql`
  query GetTaskSMS($query: ri_apps_prd_sms_history_bool_exp) {
    rows: ri_apps_prd_sms_history(where: $query) {
      sms_history_id
      task_id
      voter_id
      date_sent
      status
      from
      to
      sms_sid
      twilio_error_code
      direct_snd_status
      direct_snd_error
      updated_at
    }
  }
`;

export const GET_TASK_SURVEY_RESPONSES = gql`
  query GetTaskSurveyResponses($query: ri_apps_prd_sms_survey_responses_bool_exp) {
    rows: ri_apps_prd_sms_survey_responses(where: $query) {
      sms_survey_response_id
      task_id
      voter_id
      date_sent: created_at
      status
      from
      to
      twilio_execution_sid
      twilio_error_code
      updated_at
    }
  }
`;

export const GET_VOTER_SMS_HISTORY = gql`
  query GetVoterSms($voterId: Int!, $orgId: Int!) {
    ri_apps_prd_sms_history(
      where: {
        voter_id: { _eq: $voterId }
        _and: [
          { _or: [{ status: { _is_null: true } }, { status: { _neq: "canceled" } }] }
          {
            _or: [
              { direct_snd_status: { _is_null: true } }
              { direct_snd_status: { _neq: "CANCELED" } }
            ]
          }
        ]
        sms_history_task: {
          _or: [{ send_at: { _is_null: true } }, { send_at: { _lte: "now()" } }]
          tasks_task_campaigns: {
            task_campaigns_campaign: {
              campaigns_organization: { organization_id: { _eq: $orgId } }
            }
          }
        }
      }
    ) {
      date_sent
      created_at
      status
      sms_history_task {
        text_message
        send_at
      }
    }
  }
`;

export const CREATE_SMS_HISTORY = gql`
  mutation CreateSMSHistory($objects: [ri_apps_prd_sms_history_insert_input!]!) {
    rows: insert_ri_apps_prd_sms_history(objects: $objects) {
      affected_rows
    }
  }
`;

export const GET_VOTER_SMS_HISTORY_FOR_SUPERADMIN = gql`
  query GetVoterSms($voterId: Int!, $orgTypeId: Int!) {
    ri_apps_prd_sms_history(
      where: {
        voter_id: { _eq: $voterId }
        _and: [
          { _or: [{ status: { _is_null: true } }, { status: { _neq: "canceled" } }] }
          {
            _or: [
              { direct_snd_status: { _is_null: true } }
              { direct_snd_status: { _neq: "CANCELED" } }
            ]
          }
        ]
        sms_history_task: {
          _or: [{ send_at: { _is_null: true } }, { send_at: { _lte: "now()" } }]
          tasks_task_campaigns: {
            task_campaigns_campaign: {
              campaigns_organization: { organization_type_id: { _eq: $orgTypeId } }
            }
          }
        }
      }
    ) {
      date_sent
      created_at
      status
      sms_history_task {
        text_message
        send_at
      }
    }
  }
`;

export const GET_SMS_HISTORY_FOR_MAP = gql`
  query GetSmsHistoryForTasks($where: ri_apps_prd_sms_history_bool_exp) {
    rows: ri_apps_prd_sms_history(where: $where) {
      voter_id
      task_id
      date_sent
      status
      twilio_error_code
      sms_history_task {
        text_message
      }
    }
  }
`;

export const GET_TASK_AUDIO_TASK_HISTORIES = gql`
  query GetTaskAudioTaskHistories($query: ri_apps_prd_audio_task_histories_bool_exp) {
    rows: ri_apps_prd_audio_task_histories(where: $query) {
      audio_task_history_id
      task_id
      voter_id
      date_sent: created_at
      status
      from
      to
      call_sid
      duration
      cost
      twilio_error_code
      updated_at
    }
  }
`;
